// @flow
import React from 'react';
import { noop } from 'lodash';
import classnames from 'classnames';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

type Props = {
  className?: string,
  comparisonClick: () => void,
  comparisonToggle: () => void,
  comparisonUrl: string,
  isComparisonActive?: boolean,
  isComparisonSubmitable?: boolean,
  label: string,
  mandatoryMessage?: string,
  selectedItemsCount?: number,
  selectedItemsMax: number,
  style?: *,
};

export function SearchCompareButton(props: Props) {
  const {
    className,
    comparisonClick,
    comparisonToggle,
    comparisonUrl,
    isComparisonActive,
    isComparisonSubmitable,
    label,
    mandatoryMessage,
    selectedItemsCount,
    selectedItemsMax,
    style,
  } = props;

  const isDisabled = isComparisonActive && !isComparisonSubmitable;

  const getToggleOrComparisonOnClick = () => {
    if (isComparisonSubmitable) return comparisonClick;
    return isComparisonActive ? noop : comparisonToggle;
  };

  const trackingData = isComparisonSubmitable
    ? {
        actionGA: 'overlayCTA',
        labelGA: 'compareMySelection',
      }
    : {
        actionGA: 'overlayCTA',
        labelGA: 'compareAndBook',
      };

  return (
    <TrackClick
      aria-disabled={isDisabled}
      as={isComparisonSubmitable ? DynamicLink : 'button'}
      trackingData={trackingData}
      className={classnames(
        className,
        'reset-anchor reset-button flex items-stretch font-bold overflow-hidden rounded-small text-md text-white',
        {
          'bg-gray-light cursor-default': isDisabled,
          'bg-turquoise': !isComparisonActive && !isComparisonSubmitable,
          'bg-emerald': isComparisonSubmitable,
        },
      )}
      onClick={getToggleOrComparisonOnClick()}
      style={style}
      title={!isComparisonSubmitable ? mandatoryMessage : ''}
      {...(isComparisonSubmitable ? { url: comparisonUrl } : { type: 'button' })}
      data-testid="search-compare-button"
    >
      <span className="flex-1 p-2 text-center">{label}</span>
      {!!selectedItemsCount && (
        <span className="bg-overlay-black-15 p-2">
          {selectedItemsCount}/{selectedItemsMax}
        </span>
      )}
    </TrackClick>
  );
}
